import React, { useState, useEffect } from "react";
import styles from "../NewsRoom/Newsroom.module.css";
import newsimg from "../../assets/images/img.svg";
import up from "../../assets/images/up-arrow.svg";
import down from "../../assets/images/down-arrow.svg";
import Mail from "../../commomComponents/mail";
import Button from "../../commomComponents/button";
import getNewsRoomDetails from "../../services/request/newsRoom";
import { IMAGE_URL, SITE_ID } from "../../services/apiConstants";
import ReactHtmlParser from "react-html-parser";
import ReactPlayer from "react-player";
import sortObject from "../../utils/sortingObject";
import moment from "moment";
import BannerWithHeading from "../../commomComponents/bannerWithHeading";
import { downloadPdf } from "../../utils/downloadPdf";
import { Tooltip } from "@material-ui/core";
import Loader from "../../commomComponents/Loader";
import { sortObjectDesc } from "../../utils/commonFunctions";
import unionBudgetPdf from "../../assets/pdf/unionBudget.pdf";
import SeoHelmet from "../../commomComponents/seoHelmet";
import Blog1 from "../../assets/images/Blog1.jpg";
import Blog2 from "../../assets/images/Blog2.jpg";
import Blog3 from "../../assets/images/Blog3.jpg";
import Blog4 from "../../assets/images/Blog4.jpg";
import Blog5 from "../../assets/images/Blog5.jpg";
import { BlogContent } from "./blogContent";

export default function NewsRoom() {
  const [counter, setCounter] = useState(0);
  const [banner, setBanner] = useState({ image: "", title: "" });
  const [media, setMedia] = useState([]);
  const [commentary, setCommentary] = useState([]);
  const [interviews, setInterviews] = useState([]);
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    document.title = "Latest Market Insights & Trends - ICICI Pru Alternates";
    setLoader(true);
    const newsRoom = getNewsRoomDetails();
    newsRoom.then((data) => {
      banner["image"] = data.data.banner[0].image;
      setBanner({ ...banner });
      banner["title"] = data.data.banner[0].title;
      setBanner({ ...banner });
      setCommentary(data.data.commentary);
      setMedia(data.data.medias);
      setInterviews(sortObject(data.data.interviews, "id"));
      setLoader(false);
    });
  }, []);
  const blogsSampleData = [
    {
      id: 1,
      title: "Alternative investment funds: Meaning and types",
      // date: "NOV 14, 2024.",
      // readTime: " 6 min read.",
      image: Blog1,
      link: ""
    },
    {
      id: 2,
      title: "AIF vs PMS Understanding the Key Differences in Investment Strategies",
      // date: "DEC 02, 2024.",
      // readTime: " 2 min read",
      image: Blog2,
      link: ""
    },
    {
      id: 3,
      title: "How to choose the right portfolio management service provider",
      // date: "DEC 02, 2024.",
      // readTime: " 2 min read",
      image: Blog3,
      link: ""
    },
    {
      id: 4,
      title: "Understanding Portfolio Management Services: A Beginner’s Guide",
      // date: "DEC 02, 2024.",
      // readTime: " 2 min read",
      image: Blog4,
      link: ""
    },
    {
      id: 5,
      title: "The Benefits of Investing in Alternative Investment Funds",
      // date: "DEC 02, 2024.",
      // readTime: " 2 min read",
      image: Blog5,
      link: ""
    },
  ];
  const countUp = () => {
    let count = interviews.length;
    if (counter < count - 1) {
      setCounter(counter + 1);
    } else if (counter === count - 1) {
      setCounter(0);
    } else {
      return counter;
    }
  };

  const countDown = () => {
    let count = interviews.length;
    if (counter > 0 && counter < count) {
      setCounter(counter - 1);
    } else if (counter === 0) {
      setCounter(count - 1);
    } else {
      return counter;
    }
  };

  const handleRight = () => {
    countUp();
  };
  const handleLeft = () => {
    countDown();
  };

  const [viewmore, setViewmore] = useState(false);
  const [viewMediamore, setViewMediamore] = useState(false);
  const loadCount = viewmore ? commentary.length : 4;
  const loadBlogCount = viewmore ? blogsSampleData.length : 2;
  const loadMedia = viewMediamore ? media.length : 3;
  const loadMore = () => {
    setViewmore(true);
  };
  const loadless = () => {
    setViewmore(false);
  };

  const loadMediaMore = () => {
    setViewMediamore(true);
  };
  function scrollToSection(sectionId) {
    const element = document.getElementById(sectionId);

    if (element) {
      const headerHeight = 640;
      const offset = headerHeight;

      window.scrollTo({
        top: offset,
        behavior: "smooth", // For smooth scrolling
      });
    }
  }
  function scrollToSectionViewPoint(sectionId) {
    const element = document.getElementById(sectionId);

    if (element) {
      const headerHeight = 200;
      const offset = headerHeight;

      window.scrollTo({
        top: offset,
        behavior: "smooth", // For smooth scrolling
      });
    }
  }
  function scrollToBlogs(sectionId) {
    const element = document.getElementById(sectionId);

    if (element) {
      const headerHeight = 200;
      const offset = element.getBoundingClientRect().top + window.scrollY - headerHeight;

      window.scrollTo({
        top: offset,
        behavior: "smooth", // For smooth scrolling
      });
    }
  }
  function scrollToSection1(sectionId) {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 200;
      const offset =
        element.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({
        top: offset,
        behavior: "smooth", // For smooth scrolling
      });
    }
  }
  
  const onClickBlog = (val) => {
    let pathName = "/insights"
    if (val?.id === 1) {
      pathName = "/insights-blogs/Alternative_Investment_Funds_Meaning_and_types"
    } else if (val?.id === 2) {
      pathName = "/insights-blogs/understanding_the_key_differences_in_investment_strategies"
    } else if (val?.id === 3) {
      pathName = "/insights-blogs/how_to_choose_the_right_portfolio_management_service_provider"
    } else if (val?.id === 4) {
      pathName = "/insights-blogs/understanding_portfolio_management_services"
    } else if (val?.id === 5) {
      pathName = "/insights-blogs/benefits_of_investing_in_alternative_investment_funds"
    }
    window.open(pathName, '_blank');
  }

  return (
    <div>
      {loader === true ? (
        <Loader />
      ) : (
        <>
          <SeoHelmet
            title="Latest Market Insights & Trends - ICICI Pru Alternates"
            description="Stay informed with the latest market insights and trends. ICICI Pru Alternates provides comprehensive analysis and investment advice."
            url="https://www.iciciprualternates.com/market-insights"
          />
          <div className={styles.slides}>
            {/* {banner["image"] && (
              <BannerWithHeading
                bannerImage={IMAGE_URL + banner["image"] + SITE_ID}
                heading={banner["title"]}
              />
            )} */}
            <div className={styles.imageBanner}>
              {banner.image && (
                <img src={IMAGE_URL + banner["image"] + SITE_ID} alt="" />
              )}
            </div>
            <ul className={styles.buttonPills}>
              <li>
                <a
                  style={{ cursor: "pointer" }}
                  className={styles.btn}
                  onClick={() => scrollToSectionViewPoint("Viewpoint")}
                >
                  Viewpoint
                </a>
              </li>
              <li>
                <a
                  style={{ cursor: "pointer" }}
                  className={styles.btn}
                  onClick={() => scrollToSection("commentary")}
                >
                  Market Pulse
                </a>
              </li>
              <li>
              <a
                style={{ cursor: "pointer" }}
                className={styles.btn}
                onClick={() => scrollToBlogs("blogs")}
              >
                Blogs
              </a>
            </li>
              {/* <li>
            <a href="#media" className={styles.btn}>
              Print and Online Media
            </a>
          </li> */}
              <li>
                <a
                  style={{ cursor: "pointer" }}
                  className={styles.btn}
                  onClick={() => scrollToSection1("video")}
                >
                  Videos
                </a>
              </li>
            </ul>
          </div>
          <>
          <div className={styles.section} id="Viewpoint">
            <div className={styles.container}>
              <div className={styles.heading}>Viewpoint</div>
              <ul className={viewmore !== true ? styles.ul : styles.ulScroll}>
                {/* <li>
                  <div className={styles.listnews}>
                    <div>
                      {"UNION BUDGET FY 2025"}
                      <span className={styles.span}>
                        July 2024
                      </span>
                    </div>

                    <button
                      onClick={() => downloadPdf(unionBudgetPdf)}
                      className={styles.download}>
                      <img src={newsimg} alt="" />
                    </button>
                  </div>
                </li> */}
                {sortObjectDesc(commentary, "id")
                  .slice(0, loadCount)
                  .map((data, i) => {
                    if (data.title.includes("MARKET OUTLOOK")) {
                      <></>;
                    } else {
                      return (
                        <li key={i}>
                          <div className={styles.listnews}>
                            <div>
                              {data.title}
                              <span className={styles.span}>
                                {moment(data.updatedOn).format("MMM YYYY")}
                              </span>
                            </div>

                            {data.link ? (
                              <button
                                onClick={() => {
                                  window.dataLayer = window.dataLayer || [];
                                  window.dataLayer.push({
                                    event: "viewpointFile_download",
                                    inquiryType: "",
                                    buttonName: "",
                                    email: "", // Encrypted email of the User using SHA-256 encryption
                                    contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                    clientID: "",
                                    queryMessage: "",
                                    state: "",
                                    pageSection: "Viewpoint",
                                    Category: data.title,
                                    FAQ: "",
                                  });
                                  downloadPdf(
                                    IMAGE_URL +
                                      data?.link?.item[0]?.key +
                                      SITE_ID,
                                    data?.link?.item[0]?.fileSize_s
                                  );
                                }}
                                className={styles.download}
                              >
                                <img src={newsimg} alt="" />
                              </button>
                            ) : null}
                          </div>
                        </li>
                      );
                    }
                  })}
              </ul>
            </div>
            {!viewmore ? (
              <div className={styles.viewmore} onClick={loadMore}>
                View More {">"}
              </div>
            ) : (
              <div className={styles.viewmore} onClick={loadless}>
                View Less {">"}
              </div>
            )}
          </div>
          <div className={styles.section} id="commentary">
            <div className={styles.container}>
              <div className={styles.heading}>Market Pulse</div>
              <ul className={viewmore !== true ? styles.ul : styles.ulScroll}>
                {sortObjectDesc(commentary, "id")
                  .slice(0, loadCount)
                  .map((data, i) => {
                    if (data.title.includes("MARKET OUTLOOK")) {
                      return (
                        <li key={i}>
                          <div className={styles.listnews}>
                            <div>
                              {data.title}
                              <span className={styles.span}>
                                {moment(data.updatedOn).format("MMM YYYY")}
                              </span>
                            </div>

                            {data.link ? (
                              <button
                                onClick={() => {
                                  window.dataLayer = window.dataLayer || [];
                                  window.dataLayer.push({
                                    event: "marketOutlookFile_download",
                                    inquiryType: "",
                                    buttonName: "",
                                    email: "", // Encrypted email of the User using SHA-256 encryption
                                    contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                                    clientID: "",
                                    queryMessage: "",
                                    state: "",
                                    pageSection: "Market Pulse",
                                    Category: data.title,
                                    FAQ: "",
                                  });
                                  downloadPdf(
                                    IMAGE_URL +
                                      data?.link?.item[0]?.key +
                                      SITE_ID,
                                    data?.link?.item[0]?.fileSize_s
                                  );
                                }}
                                className={styles.download}
                              >
                                <img src={newsimg} alt="" />
                              </button>
                            ) : null}
                          </div>
                        </li>
                      );
                    } else {
                      <></>;
                    }
                  })}
              </ul>
            </div>
            {!viewmore ? (
              <div className={styles.viewmore} onClick={loadMore}>
                View More {">"}
              </div>
            ) : (
              <div className={styles.viewmore} onClick={loadless}>
                View Less {">"}
              </div>
            )}
          </div>
          <div className={styles.section} id="blogs">
            <div className={styles.container}>
              <div className={styles.heading}>Blogs</div>
              <ul className={`${viewmore !== true ? styles.ul : styles.ulScroll} ${styles.blogContainer}`}>
                  {blogsSampleData.slice(0,loadBlogCount).map((blog) => {
                    return (<>
                      <li key={blog?.id} onClick={() => { onClickBlog(blog) }} className={styles.blogCard}>
                        <img src={blog.image} alt="img" className={styles.blogImage} />
                        <div className={styles.blogTitleFont} >{blog?.title}</div>
                        {/* <div className={styles.blogDateFont}>{blog?.date}, {blog?.readTime}</div> */}
                        <div className={styles.blogReadMore}>
                          Read more
                        </div>
                      </li>
                    </>)
                  })}
                
              </ul>
            </div>
            {!viewmore ? (
              <div className={styles.viewmore} onClick={loadMore}>
                View More {">"}
              </div>
            ) : (
              <div className={styles.viewmore} onClick={loadless}>
                View Less {">"}
              </div>
            )}
          </div>
          <div className={styles.section} id="video">
            <div className={styles.container}>
              <div className={styles.heading}>Videos</div>
              {interviews.length !== 0 && (
                <div className={styles.row}>
                  <div className={styles.slidetitle}>
                    <h2 className={styles.vdtitle}>
                      {interviews[counter].title}
                    </h2>
                    <p className={styles.vddate}>
                      {moment(interviews[counter].updatedOn).format(
                        "Do MMM YYYY"
                      )}
                    </p>
                    <p className={styles.vddetails}>
                      {ReactHtmlParser(interviews[counter].content)}
                    </p>
                  </div>
                  <div
                    className={styles.video}
                    onClick={() => {
                      window.dataLayer = window.dataLayer || [];
                      window.dataLayer.push({
                        event: "Video_view",
                        inquiryType: "",
                        buttonName: "",
                        email: "", // Encrypted email of the User using SHA-256 encryption
                        contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                        clientID: "",
                        queryMessage: "",
                        state: "",
                        pageSection: "Videos",
                        Category: "",
                        FAQ: "",
                      });
                    }}
                  >
                    <ReactPlayer
                      url={interviews[counter].link}
                      width="100%"
                      height="100%"
                      id="myId"
                      className={styles.myReactPlayer}
                      display="initial"
                      position="relative"
                      controls="true"
                    />
                  </div>
                  <div className={styles.vdslide}>
                    <div className={styles.arrow}>
                      <img src={up} alt="up-arrow" onClick={handleLeft} />
                    </div>

                    <div className={styles.slidercount}>
                      {interviews[counter].id}/{interviews.length}
                    </div>

                    <div className={styles.arrow}>
                      <img src={down} alt="down-arrow" onClick={handleRight} />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          </>
          <Mail />
        </>
      )}
    </div>
  );
}
